import React, { useRef, forwardRef, useImperativeHandle } from "react";
import { Calendar } from "primereact/calendar";
import { useTranslation } from "react-i18next";

const DateRangePicker = forwardRef(({
  dates,
  setDates,
  placeholder = "Date",
  showButtonBar = true,
  selectionMode = "range",
  isDateRangePicker = true,
  className =""
}, ref) => {
  const { t } = useTranslation();
  const calendarRef = useRef(null);

  useImperativeHandle(ref, () => ({
    hide: () => calendarRef.current?.hide(),
  }));

  const hasValue = Array.isArray(dates)
    ? dates?.some((d) => d)
    : !!dates;

  const handleChange = (e) => {
    setDates(e.value);
  };

  return (
    <div className={`date_range_picker ${hasValue ? "has-value" : ""} ${className}`}>
      <Calendar
        ref={calendarRef}
        value={dates}
        onChange={handleChange}
        selectionMode={selectionMode}
        readOnlyInput
        hideOnRangeSelection
        showIcon
        placeholder={t(placeholder)}
        showButtonBar={showButtonBar}
        maxDate={isDateRangePicker ? new Date() : undefined}
        dateFormat="dd/mm/yy"
      />
    </div>
  );
});

export default DateRangePicker;